import { createReducer, on } from "@ngrx/store";
import { initialApuCategoryTypeState, apuCategoryTypeAdapter } from "./apu-category-type.state";
import { ApuCategoryTypeActions } from "./apu-category-type.actions";

export const apuCategoryTypeReducer = createReducer(
    initialApuCategoryTypeState,
    on(ApuCategoryTypeActions.loadApuCategoryTypeSuccess, (state, action) => {
        return apuCategoryTypeAdapter.setAll(action.apuCategoryTypes, {
            ...state,
            errorMessage: null
        });
    })
);